import React from 'react';
import './Category.css';

import { formatCategoryName } from '../../utils';

import { Link } from 'react-router-dom';


const Category = (props) => {

  const { category, image, menuType = 'general' } = props; // Default to 'general' if not specified

  const encodedQuery = encodeURIComponent(category); // Encode the category string to be URL-safe
  const formattedTitle = formatCategoryName(category); // Format the category title for display (e.g., capitalize)

  return (
    <div key={category} className="category-item">

      {/* Display category image */}
      <img src={image} alt={formattedTitle} />

      <div className="content">

        {/* Link to the Menu page with the category name */}
        <Link
          to={`/Menu/${encodedQuery}`} 
          state={{ menuType }} // Pass the menuType via state
        >
          <h3>{formattedTitle}</h3>
        </Link>

        {/* Button-style link to the same menu page */}
        <Link 
          to={`/Menu/${encodedQuery}`} 
          state={{ menuType }} // Pass the same menuType here
          className='btn'
        >
          See Menu
        </Link>

      </div>

    </div>
  );
};

export default Category;